import { Component } from '@angular/core';

@Component({
  selector: 'num-error-log-header',
  templateUrl: './error-log-header.component.html',
  styleUrls: ['./error-log-header.component.scss'],
})
export class ErrorLogHeaderComponent {}
